import moment from 'moment-timezone';

const getMinMaxPage = (date: string, locale: string, timezone: string) => {
	const momentDate = moment(date).locale(locale).tz(timezone).add(1, 'month');
	return {
		month: momentDate.month(),
		year: momentDate.year()
	};
};

export default getMinMaxPage;
